// Mağaza yetkilisi: KVKK Taahhütnamesi + Aydınlatma Yükümlülüğü → indir, imzala, yükle
import { Download, ShieldCheck, Clock3, XCircle, CheckCircle2 } from 'lucide-react';
import { DocumentUploadButton } from '../employees/DocumentUploadButton';
import { API } from './storeShared';

const DOCS = [
  { key: 'kvkk_taahhutnamesi', label: 'KVKK Taahhütnamesi', path: 'kvkk-template' },
  { key: 'aydinlatma_yukumlulugu', label: 'Aydınlatma Yükümlülüğü', path: 'aydinlatma-template' },
];

const DocRow = ({ d, state, companyId, onUploaded }) => (
  <div className="flex flex-wrap items-center gap-2 border-t pt-3 first:border-0 first:pt-0" data-testid={`store-doc-${d.key}`}>
    <span className="min-w-40 flex-1 text-sm font-medium text-slate-800">{d.label}</span>
    {state === 'onay' && <span className="flex items-center gap-1 text-xs font-medium text-emerald-700"><CheckCircle2 className="h-4 w-4" />Onaylandı</span>}
    {state === 'beklemede' && <span className="flex items-center gap-1 text-xs font-medium text-amber-700"><Clock3 className="h-4 w-4" />İSG onayı bekleniyor</span>}
    {state === 'eksik' && <span className="flex items-center gap-1 text-xs font-medium text-rose-700"><XCircle className="h-4 w-4" />Reddedildi, yeniden yükleyin</span>}
    {['yok', 'eksik'].includes(state) && (
      <>
        <a href={`${API}/public/${d.path}`} className="inline-flex items-center gap-1.5 rounded-md border px-3 py-1.5 text-xs font-medium text-slate-700 hover:bg-slate-50" data-testid={`store-download-${d.key}`}><Download className="h-3.5 w-3.5" />Şablonu İndir</a>
        <DocumentUploadButton entityType="companies" entityId={companyId} docKey={d.key} hasFile={false} onUploaded={onUploaded} label="İmzalı Belgeyi Yükle" />
      </>
    )}
  </div>
);

export const StoreKvkkCard = ({ quota, onUploaded }) => (
  <div className="space-y-3 rounded-lg border bg-white p-4" data-testid="store-kvkk-card">
    <p className="text-xs text-slate-500">Her belge için: şablonu indirin → doldurup kaşe ve yetkili imzası ile onaylayın → taranmış hâlini veya fotoğrafını yükleyin.</p>
    {DOCS.map(d => <DocRow key={d.key} d={d} state={quota.docs?.[d.key] || 'yok'} companyId={quota.company_id} onUploaded={onUploaded} />)}
    <p className="flex items-center gap-1.5 text-xs text-slate-500"><ShieldCheck className="h-3.5 w-3.5" />İki belge de İSG birimi tarafından onaylandığında sınırsız talep oluşturabilirsiniz.</p>
  </div>
);
